import { getTypeColor } from '@/utils/nodeTypeMapper';
import { alpha, Box, Chip, Divider, Stack, Typography } from '@mui/material';
import CollapsibleAlert from './CollapsibleAlert';

const modeConfig = {
  add: {
    actionWord: 'oprettelse',
    verb: 'oprette',
  },
  edit: {
    actionWord: 'ændring',
    verb: 'redigere',
  },
  delete: {
    actionWord: 'fjernelse',
    verb: 'fjerne',
  },
  move: {
    actionWord: 'flytning',
    verb: 'flytte',
  },
};

const InitiativeInclusionNotice = ({
  virtualInitiativeInclusions,
  mode = 'add',
}) => {
  if (!virtualInitiativeInclusions || virtualInitiativeInclusions.length === 0)
    return null;

  const { actionWord, verb } = modeConfig[mode] || modeConfig.edit;
  const count = virtualInitiativeInclusions.length;

  const summary = `Påvirker ${count} initiativ(er) via virtuel opsamlingsnode – klik for detaljer`;

  return (
    <CollapsibleAlert severity="warning" summary={summary}>
      <Typography variant="body2" gutterBottom>
        Den valgte node indgår i eksisterende initiativer via en
        <strong> virtuel opsamlingsnode</strong>. Ved at <strong>{verb}</strong>{' '}
        denne node kan disse initiativer få ændret deres datagrundlag og dermed
        blive misvisende. Overvej at gennemgå de berørte initiativer efter{' '}
        {actionWord}
      </Typography>
      <Divider sx={{ my: 1 }} />
      <Box sx={{ mt: 1 }}>
        <Typography
          variant="caption"
          sx={{
            textTransform: 'uppercase',
          }}
        >
          Berørte initiativer
        </Typography>

        <Stack
          spacing={0.25}
          sx={{
            mt: 0.5,
            maxHeight: 200,
            overflowY: 'auto',
          }}
        >
          {virtualInitiativeInclusions.map(({ initiative, viaNode }) => {
            const initiativeLabel =
              initiative.name ||
              initiative.title ||
              `Initiativ #${
                initiative.energyInitiativeId || initiative.id || ''
              }`.trim();

            const viaLabel =
              viaNode?.name ||
              `Node #${viaNode?.energyTreeNodeId || viaNode?.EnergyTreeNodeId}`;

            const viaColor = getTypeColor(viaNode?.type) || 'grey';

            return (
              <Stack
                key={
                  initiative.energyInitiativeId ||
                  initiative.id ||
                  initiative.guid
                }
                direction="row"
                alignItems="center"
                spacing={1}
                sx={(theme) => ({
                  px: 0.75,
                  py: 0.5,
                  borderRadius: 1,
                  transition: 'background-color 120ms ease',
                  '&:hover': {
                    bgcolor: alpha(theme.palette.warning.main, 0.04),
                  },
                })}
              >
                <Box sx={{ minWidth: 0, flexGrow: 1 }}>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 500,
                      color: 'text.primary',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      overflow: 'hidden',
                    }}
                  >
                    {initiativeLabel}
                  </Typography>
                </Box>
                via
                <Chip
                  label={viaLabel}
                  size="small"
                  variant="filled"
                  sx={{
                    flexShrink: 0,
                    borderRadius: 1,
                    borderColor: viaColor,
                    color: '#fff',
                    bgcolor: viaColor,
                  }}
                />
              </Stack>
            );
          })}
        </Stack>
      </Box>
    </CollapsibleAlert>
  );
};

export default InitiativeInclusionNotice;
